import { render } from "./GameDetailsPage.vue?vue&type=template&id=17c2f386&scoped=true"
import script from "./GameDetailsPage.vue?vue&type=script&lang=js"
export * from "./GameDetailsPage.vue?vue&type=script&lang=js"

import "./GameDetailsPage.vue?vue&type=style&index=0&id=17c2f386&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c2f386"]])

export default __exports__